exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{.stacked-divs[data-v-361d77c7]{max-width:100%!important;width:100%!important}.flex-item[data-v-361d77c7],.my-3[data-v-361d77c7]{display:block}.flex-item[data-v-361d77c7]{width:100%;page-break-inside:avoid}.flex-item .float-right[data-v-361d77c7]{margin-left:auto}.no-print[data-v-361d77c7]{display:none!important}body[data-v-361d77c7]{margin:0}.no-print[data-v-361d77c7]{display:none}.avoid-break[data-v-361d77c7]{page-break-inside:avoid}.page-break-before[data-v-361d77c7]{page-break-before:always}.page-break-after[data-v-361d77c7]{page-break-after:always}.print-container[data-v-361d77c7]{overflow:visible}}", ""]);

// exports
